var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7065 1.69817C4.79972 1.60626 4.87374 1.49673 4.92426 1.37596C4.97478 1.25519 5.00079 1.12559 5.00079 0.994675C5.00079 0.863763 4.97478 0.734157 4.92426 0.613387C4.87374 0.492617 4.79972 0.383092 4.7065 0.291175C4.51748 0.104608 4.26259 0 3.997 0C3.73142 0 3.47652 0.104608 3.2875 0.291175L0.322502 3.23117C0.220308 3.33251 0.139193 3.45308 0.0838375 3.58592C0.028482 3.71877 -1.81198e-05 3.86126 -1.81198e-05 4.00517C-1.81198e-05 4.14909 0.028482 4.29158 0.0838375 4.42443C0.139193 4.55727 0.220308 4.67784 0.322502 4.77917L3.2775 7.70917C3.46656 7.89604 3.72168 8.00084 3.9875 8.00084C4.25333 8.00084 4.50844 7.89604 4.6975 7.70917C4.79072 7.61726 4.86474 7.50773 4.91526 7.38696C4.96578 7.26619 4.99179 7.13659 4.99179 7.00567C4.99179 6.87476 4.96578 6.74516 4.91526 6.62439C4.86474 6.50362 4.79072 6.39409 4.6975 6.30217L2.3795 4.00517L4.7065 1.69817Z",
    fill: "#42526E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleLeft);
export default __webpack_public_path__ + "static/media/toggleLeft.358ad2e52d91d19efb186ae7a0fc4ae1.svg";
export { ForwardRef as ReactComponent };